module.exports = __webpack_public_path__ + "static/media/17_potolok_7.66_0.9bbe0371.png";